import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Box, Tooltip} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import {useSelector} from "react-redux";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import {useLocation, useNavigate} from "react-router-dom";
import Api from "../../../utils/api";
import {Loading, Head, ProductAutoComplete} from "../../../components";
import AsnafProductDialogForm from "../../../components/Asnaf/product";
import queryString from 'query-string';

const AsnafProduct = () => {

    const AppState = useSelector(state => state);

    const history = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        product_id: query.product_id ? parseInt(query.product_id) : "",
    });
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState([]);

    const handleChangeSearchInputWithAutoComplete = (name, value) => {
        _makeQueryStringParams(name, value)
    }


    const handleRequest = () => {
        new Api().get('/asnaf/product', {
            page: params.page,
            limit: params.limit,
            product_id: params.product_id,
        }).then((resp) => {
            if (typeof resp !== "undefined") {
                setResponse(resp);
            }

            setLoading(false);
        })
    }

    useEffect(() => {

        handleRequest();

        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.page,
        params.limit,
        params.product_id,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if (n_params.page !== parseInt(query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'limit':
                    if (n_params.limit !== parseInt(query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'product_id':
                    if (n_params.product_id !== parseInt(query.product_id)) {
                        n_params.product_id = parseInt(query.product_id);
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.page,
        query.limit,
        query.product_id,
    ]);


    const _makeQueryStringParams = (type, value) => {

        let n_params = params;

        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
            case 'limit':
                n_params.limit = value;
                break;
            case 'product_id':
                n_params.product_id = value;
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&limit=${n_params.limit}`;
        url += `&product_id=${n_params.product_id}`;

        history(`/asnaf/product/${url}`);

    };


    const pageCount = Math.ceil(parseInt(response?.total) / parseInt(response?.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'ارسال اطلاعات به وزارتخانه', 'description': 'بخش محصولات' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <ProductAutoComplete multiple={false} onChange={(value) => handleChangeSearchInputWithAutoComplete('product_id', value ? value.id : '')}/>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <AsnafProductDialogForm onComplete={() => handleRequest()} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>محصول</th>
                        <th>نتیجه درخواست</th>
                        <th>وضعیت</th>
                        <th>تاریخ ایجاد</th>
                    </tr>
                    </thead>
                    <tbody>
                    {response.data && response.data.map((item, index) => {
                        return(
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.product && item.product.title}</td>
                                <td style={{ direction: 'ltr'}}>{item.message}</td>
                                <td style={{ direction: 'ltr'}}><b className={'status-' + item.status}>{AppState.marketer.document_status && AppState.marketer.document_status[item.status]}</b></td>
                                <td style={{ direction: 'ltr'}}>{moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading />}
        </Container>
    );

}

export default AsnafProduct;